export const itemizedBillColumns = [
  'r1_id',
  'account_number',
  'revenue_code',
  'cpt_hcpcs',
  'service_line_period',
  'flat_file_service_line_amount',
  'claim_service_line_amount',
  'flat_file_service_line_unit_count',
  'claim_service_line_unit_count',
  'flat_file_modifiers',
  'claim_modifiers',
  'charge_categories',
];
